import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  size: 'full',
  path: 'financial_workspace',
  children: {
    employee_costs: {
      size: 'full',
      path: 'employee-costs',
    },
    payroll: {
      size: 'full',
      path: 'payroll',
    },
  },
} as const satisfies Location
